module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/795573a9d2fee5058a63cf5ec067fa3e.png";